import ButtonStandard from './ButtonStandard';
import ButtonStandardLessMargin from './ButtonStandardLessMargin';

export default ButtonStandard;
export { ButtonStandardLessMargin, ButtonStandard };
